<div class="main_content px-3 position-relative w-100">
  <div class="container-fluid py-3">
    <div class="title mb-2">
      <h2 class="base_url review_list">Reviews Pending / Completed</h2>
    </div>
    <div class="white_box shadow p-3">
      <!-- <p>{{google_feedbacks[0]|json}}</p> -->
      <select name="" id="" (change)="unhide($event.target.value, 0)">
        <option value="">Un-Hide User</option>
        <option *ngFor="let name of hideAdminData" value="{{ name?.id }}">
          {{ name?.email }}
        </option>
      </select>
      <div
        class="d-flex align-items-center flex-wrap mb-3 gray_box"
        *ngIf="chaeckAdminStatus == 'Admin'"
      >
        <div *ngFor="let name of subAdminData; let i = index">
          <div class="tabs_click">
            <a class="btn" (click)="hideURL(name.id, 1)">X</a>
            <div
              class="overlay_box btn {{
                flag == name?.id ? 'btn-success' : ''
              }}"
              (click)="getDataByUser(name?.id)"
            >
              {{ name?.email }}
            </div>
          </div>
        </div>
        <!-- <div class="overlay_box">not iterable</div> -->
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <!-- <button class="btn btn-secondary add_goo_rev" (click)="open_google_review_modal()" >Add Reviews</button> -->
              <div class="goo_bg">
                <table class="table">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col">S.No.</th>
                      <th scope="col">SMS</th>
                      <!-- <th scope="col">Name</th> -->
                      <th scope="col">Review Link</th>
                      <th scope="col">Review</th>
                      <th scope="col">Stars</th>
                      <th scope="col">Start</th>
                      <th scope="col">Completed</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let feedback of google_feedbacks; let i = index"
                    >
                      <th scope="row">{{ googlecoundata - i }}</th>
                      <th scope="row">
                        <a
                          (click)="
                            sendsms(
                              phone,
                              feedback.id,
                              feedback.description,
                              feedback?.feedback_name?.feedbackManager
                                ?.review_link ||
                                feedback?.feedbackManager_reviewLink
                            )
                          "
                        >
                          <i class="fa-solid fa-message">
                            <span> {{ feedback.smscount }}</span>
                          </i></a
                        >
                      </th>
                      <!-- <td>
                        {{ feedback.feedbackNameurl }} 
                      </td> -->
                      <td>
                        {{
                          feedback?.feedbackManager_reviewLink?.substring(0, 20)
                        }}
                      </td>
                      <td>{{ feedback.description?.substring(0, 20) }}</td>
                      <td class="ngb_rate_td">
                        <p class="ngb_rate">
                          <ngb-rating
                            [(rate)]="feedback.star"
                            [max]="5"
                            [readonly]="true"
                            class="gift"
                          ></ngb-rating>
                        </p>
                      </td>
                      <td>
                        {{ feedback.created * 1000 | date : "dd/MM/yyyy" }}
                      </td>
                      <td>
                        {{ feedback.updated * 1000 | date : "dd/MM/yyyy" }}
                      </td>

                      <td>
                        <!-- <a (click)="imageUpload(test)">aaaaaa</a> -->

                        <a
                          (click)="editReview(content, feedback.id, feedback)"
                          class="btn btn-info"
                        >
                          <i class="fas fa-edit"></i
                        ></a>
                        &nbsp;
                        <a
                          *ngIf="
                            feedback.is_verify == 0 &&
                            chaeckAdminStatus == 'subAdmin'
                          "
                          class="btn btn-danger"
                          >Pending</a
                        >
                        <a
                          (click)="imageUpload(test, feedback.id)"
                          *ngIf="
                            feedback.is_verify == 0 &&
                            chaeckAdminStatus == 'Admin'
                          "
                          class="btn btn-danger"
                          >Pending</a
                        >
                        <a
                          (click)="viewlimage(view, feedback.id)"
                          *ngIf="feedback.is_verify == 1"
                          class="btn btn-success"
                          >Completed</a
                        >
                        <!-- <a  *ngIf="feedback.is_verify==0" ><i class='fa-solid fa-circle' style='color: red'></i></a>
                            <a   *ngIf="feedback.is_verify==1" ><i class='fa-solid fa-circle' style='color: green'></i></a> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Edit Review</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">x</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>
    <form action="">
      <div class="modal-body">
        <form [formGroup]="editFG">
          <div class="form-group">
            <select
              class="form-control"
              formControlName="feedbackNameurl"
              (change)="onChange($event.target.value)"
            >
              <!-- <option  [selected]  >Select name</option> -->
              <option
                *ngFor="let url of url_names.findFeedbackNames"
                value="{{ url.url_name }}"
              >
                {{ url.url_name }}
              </option>
            </select>
            <br />

            <select
              name=""
              id=""
              class="form-control"
              formControlName="feedbackName"
              (change)="subonChange($event.target.value)"
            >
              <option
                *ngFor="let feedbackname of get_all_feedback_URL"
                value="{{ feedbackname.description }}"
                selected="{{
                  feedbackname.feedbackName == feedbackname.description
                }}"
              >
                {{ feedbackname.description }}
              </option>
            </select>
            <br />

            <textarea
              class="form-control"
              placeholder="Write feedback"
              formControlName="description"
              >{{ edit_google_feedbacks.description }}</textarea
            >

            <div class="feedback_rating float-none pt-0">
              <p>
                <ngb-rating
                  [(rate)]="edit_google_feedbacks.star"
                  formControlName="star"
                  max="5"
                  class="gift"
                ></ngb-rating>
              </p>
            </div>
          </div>
          <div class="text-center">
            <button
              class="btn btn-primary mx-auto"
              (click)="update_edit_google_feedbacks()"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #phone let-modal class="edite_modle">
  <div class="edite_modle">
    <div class="modal-header justify-content-center">
      <h4 class="modal-title">Send SMS</h4>
      <!-- <h3 class="text-center">Edit Review</h3> -->

      <a class="btn-close ml-auto" (click)="modal.dismiss('Cross click')">X</a>
      <!-- <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button> -->
    </div>

    <form [formGroup]="send_Message">
      <div class="modal-body">
        <div class="mb-3">
          <label for="type">Phone Number</label>
          <select
            class="right-side form-control"
            #selectformnames
            (change)="onSelectName(selectformnames.value)"
          >
            <option value="">Select from Names</option>
            <option value="{{ data.phno }}" *ngFor="let data of getallname">
              {{ data.name }}
            </option>
          </select>
          <div class="input-group">
            <input
              id="type"
              type="text"
              class="form-control"
              placeholder="Please Enter Phone No"
              formControlName="phone"
              oninput="this.value = this.value.replace(/[^0-9|+]/g, '');"
            />
            <ng-container *ngIf="submitted && send_Message_v.phone.errors">
              <p
                class="error-message-repair"
                *ngIf="send_Message_v.phone.errors.required"
              >
                Phone is required!
              </p>
            </ng-container>
            <!-- <button class="btn btn-outline-secondary bi bi-calendar3" (click)="dp.toggle()" type="button"></button> -->
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="sendMessage()" class="btn btn-success">Send</button>
        <!-- <button
      type="button"
      class="btn btn-outline-dark"
      (click)="modal.close('Save click')"
    >
      Send
    </button> -->
      </div>
    </form>
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Inbox ID</th>
          <th scope="col">Phone Number</th>
          <th scope="col">Date</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let message of feedbackMessages">
          <td>{{ message.inboxId }}</td>
          <td>{{ message.phone }}</td>
          <td class="ngb_rate_td">{{ formateDate(message.created) }}</td>
          <td>{{ message.status }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #test let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Upload image</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body">
    <form [formGroup]="imageUploadForm">
      <input
        type="file"
        name=""
        id=""
        class="form-control"
        accept="image/*"
        (change)="onFileChanged($event)"
      />
      <br />
      <select name="" id="" class="form-control">
        <option value="{{ data.id }}" *ngFor="let data of getallname">
          {{ data.name }}
        </option>
        <!-- <option value="">Administrator</option> -->
      </select>
      <ng-container *ngIf="submitted && imageUploadForm_v?.subadminid?.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.subadminid.errors.required"
        >
          subadminid is required!
        </p>
      </ng-container>
      <br />
      <input
        type="text"
        class="form-control"
        placeholder="Remark"
        formControlName="remark"
      />
      <ng-container *ngIf="submitted && imageUploadForm_v.remark.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.remark.errors.required"
        >
          remark is required!
        </p>
      </ng-container>
      <br />
      <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div>
    </form>
  </div>
  <!-- <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div> -->
</ng-template>

<ng-template #view let-modal class="">
  <div class="modal-header">
    <h4 class="modal-title">View image</h4>
    <a (click)="modal.dismiss('Cross click')"
      ><i class="fa fa-window-close" aria-hidden="true"></i
    ></a>
  </div>
  <div class="modal-body text-center">
    <img loading="lazy" class="modal_sm_img" src="{{ imgUrl }}{{ imagepreview }}" alt="" />
    <form [formGroup]="imageUploadForm">
      <!-- <input
        type="file"
        name=""
        id=""
        class="form-control"
        accept="image/*"
        (change)="onFileChanged($event)"
      />
      <br /> -->
      <!-- <select name="" id="" class="form-control" formControlName="subadminid">
        <option *ngFor="let name of subAdmainName" value="{{ name.id }}">
          {{ name.userName }}
        </option>
      </select> -->
      <!-- <ng-container *ngIf="submitted && imageUploadForm_v.subadminid.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.subadminid.errors.required"
        >
          subadminid is required!
        </p>
      </ng-container>
      <br /> -->
      <!-- <input
        type="text"
        class="form-control"
        placeholder="Remark"
        formControlName="remark"
      /> -->
      <!-- <ng-container *ngIf="submitted && imageUploadForm_v.remark.errors">
        <p
          class="error-message-repair"
          *ngIf="imageUploadForm_v.remark.errors.required"
        >
          remark is required!
        </p>
      </ng-container>
      <br /> -->
      <!-- <div class="modal-footer">
        <button class="btn btn-success" (click)="verify_review_token()">
          Save
        </button>
      </div> -->
    </form>
  </div>
  <!-- <div class="modal-footer">
    <button
      type="button"
      class="btn btn-light"
      (click)="modal.close('Close click')"
    >
      Close
    </button>
  </div> -->
</ng-template>
